import React from 'react';
import {Stack, Typography} from '@mui/material';

/**
 * Task card for statements requiring references
 */
export default function StatementTaskCard({task}) {
    return (
        <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary" sx={{fontSize: '0.8rem'}}>
                Statement requiring citation:
            </Typography>
            <Typography
                variant="body2"
                sx={{
                    fontSize: '0.875rem',
                    lineHeight: 1.5,
                    fontStyle: 'italic',
                    pl: 1,
                    borderLeft: 2,
                    borderColor: 'primary.main',
                }}
            >
                {task?.text || 'No text available'}
            </Typography>
        </Stack>
    );
}
